import { DropdownItemType } from '@openeducation/oe-it-components';
import { teacherProfileAtom } from '@openeducation/oe-it-jotai-atoms';
import { useEnvironmentContext } from '@openeducation/oe-it-providers';
import { useAtomValue } from 'jotai';
import { useMemo, useState } from 'react';
import { useMutation } from 'react-query';

import { useRole } from './use-role';
import { MessageService } from '../services/message.service';

const recipientsOptions = [
  { value: 'Monitors', key: 3 },
  { value: 'Senior Monitors', key: 4 },
  { value: 'Teachers', key: 2 },
];

export function useMessageCompose() {
  const { environment } = useEnvironmentContext();
  const teacherProfile = useAtomValue(teacherProfileAtom);
  const { isAdmin } = useRole();

  const [recipients, setRecipients] = useState<number[]>([]);

  const { mutateAsync: onSend, isLoading: isSending } = useMutation(
    ({
      message,
      expirationDateTime,
    }: {
      message: string;
      expirationDateTime: number;
    }) => {
      const roles =
        recipients.length !== 0
          ? recipients
          : recipientsOptions.map((item) => item.key);

      return MessageService.create(environment, {
        notification: message,
        roles,
        expirationDateTime,
        sentByPersonId: teacherProfile?.id,
      });
    }
  );

  const onChange = (item: DropdownItemType) => {
    const key = Number(item.key);
    setRecipients((values) => {
      if (!values?.includes(key)) {
        return [...values, key];
      }
      return values.filter((value) => value !== key);
    });
  };

  const recipientsLabel = useMemo(() => {
    if (recipients.length === 0) {
      return 'Select recipients';
    }

    const selected = [] as string[];

    recipients.map((item) => {
      const recipient = recipientsOptions.find((option) => option.key === item);
      if (recipient) {
        selected.push(recipient?.value);
      }
    });

    return selected.join(', ');
  }, [recipients]);

  return {
    canComposeMessages: isAdmin,
    recipientsOptions,
    recipientsLabel,
    onChange,
    onSend,
    isSending,
  };
}
